// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7115) return "static/chunks/7115-2daa73ade9ea6104.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"5acffb37614067e3","2937":"e4ecc13838fc5435","4290":"83594e54d237e5d3","9365":"c6014b112deba8b2"}[chunkId] + ".js";
};